var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.user.includes('Company'))?_c('Empresa'):(_vm.user.includes('InternalCommercial'))?_c('ComercialInterno'):(_vm.user.includes('ExternalCommercial'))?_c('ComercialExterno'):(_vm.user.includes('Appraiser'))?_c('Tasador'):(_vm.user.includes('Validator'))?_c('Validador'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }